import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonumentoNoFoto = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 36,
	viewBox: "0 0 30 36",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_d_981_10882)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M2 7.5C2 4.73858 4.23858 2.5 7 2.5H21C23.7614 2.5 26 4.73858 26 7.5V21.5C26 24.2614 23.7614 26.5 21 26.5H18.5L14.848 31.3693C14.4341 31.9212 13.5987 31.8981 13.216 31.324L10 26.5H7C4.23858 26.5 2 24.2614 2 21.5V7.5Z",
			fill: "#CF4130"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_981_10882",
		x: 0,
		y: .5,
		width: 30,
		height: 36,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0.46 0 0 0 0 1 0 0 0 0.41 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_981_10882"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_981_10882",
				result: "shape"
			})
		]
	}) })]
});
export default SvgMonumentoNoFoto;
